const dataLegend = [
  {
    id: "fibre_dediee",
    title: null,
    helpTitle: "Fibre Dédiée Entreprise",
    description:
      "La fibre dédiée vous offre une connexion en fibre optique garantie et symétrique allant jusqu’à 10 Gbit/s.",
    color: null,
    minLegendDescription: "Offre indisponible",
    maxLegendDescription: "Maximum d’offres proposées",
    maxOpacity: 0.39
  },
  {
    id: "fibre_mutualisee",
    title: null,
    helpTitle: "Fibre Mutualisée",
    description:
      "La fibre mutualisée vous offre une connexion en fibre optique asymétrique et non-garantie.",
    color: null,
    minLegendDescription: "Offre indisponible",
    maxLegendDescription: "Maximum d’offres proposées",
    maxOpacity: 0.39
  },
  {
    id: "mobile_4g",
    title: null,
    helpTitle: "Réseau 4G",
    description:
      "4ème génération des standards pour la téléphonie mobile avec un cœur de réseau utilisant la voix sur IP.",
    color: null,
    minLegendDescription: "Offre indisponible",
    maxLegendDescription: "Maximum d’offres proposées",
    maxOpacity: 0.39
  },
  {
    id: "cuivre",
    title: null,
    helpTitle: "Cuivre",
    description:
      "Le réseau cuivre correspond à la partie de la ligne téléphonique du client jusqu’à l’équipement de l’opérateur.",
    color: null,
    minLegendDescription: "Faible débit",
    maxLegendDescription: "Meilleur débit",
    maxOpacity: 0.39
  }
];

export default dataLegend;
